<template>
  <div class="common-dropdown">
    <button type="button"
            ref="dropButton"
            class="dropdown-button"
            @click.stop="toggleOnClick">
      <slot></slot>
      <i v-if="$props.chevronVisible"
         class="dropdown-icon icon-sc-chevron-down"
         :class="{'active': dropdownVisible}"></i>
    </button>
    <div ref="dropdown" class="dropdown-content" v-show="dropdownVisible">
      <transition name="fade" mode="out-in">
        <div class="dropdown-container" v-if="dropdownVisible">
          <slot name="content"></slot>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { createPopper } from '@popperjs/core'

export default {
  name: 'common-dropdown',
  props: {
    chevronVisible: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      dropdownVisible: false,
      popperjs: null
    }
  },
  methods: {
    createPopup () {
      const drop = this.$refs.dropButton
      const dropdown = this.$refs.dropdown
      this.$nextTick(() => {
        this.popperjs = createPopper(drop, dropdown, {
          placement: 'bottom',
          strategy: 'absolute',
          modifiers: [
            {
              name: 'flip',
              options: {
                fallbackPlacements: ['bottom'],
                padding: 5,
                rootBoundary: 'viewport',
                allowedAutoPlacements: ['bottom', 'top']
              }
            },
            {
              name: 'offset',
              options: {
                offset: [0, 1]
              }
            },
            {
              name: 'preventOverflow'
            }
          ]
        })
      })
    },
    closePopup () {
      this.dropdownVisible = false
      if (this.popperjs) {
        this.popperjs.destroy()
      }
      this.popperjs = null
    },
    toggleOnClick () {
      this.dropdownVisible = !this.dropdownVisible
    },
    handleDocumentClick (e) {
      if (e.target !== this.$refs.dropButton) {
        this.closePopup()
      }
    }
  },
  watch: {
    dropdownVisible (newVal) {
      if (newVal) this.createPopup()
      else this.closePopup()
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.createPopup()
      document.addEventListener('click', this.handleDocumentClick)
    })
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleDocumentClick)
  }
}
</script>

<style scoped lang="scss">
.common-dropdown {
  position: relative;

  .dropdown-button {
    padding: 1.6rem 3.2rem 1.6rem 2.4rem;
    text-align: left;
    display: block;
    width: 100%;
    position: relative;

    > * {
      pointer-events: none;
    }

    .dropdown-icon {
      position: absolute;
      top: 50%;
      right: 2.4rem;
      transform: translateY(-50%);
      font-size: 1.6rem;
      color: $primary;
      transition: transform 0.2s ease-in-out;

      &.active {
        transform: translateY(-50%) rotate(180deg);
      }
    }
  }

  .dropdown-content {
    width: 100%;
    z-index: map_get($z-index, modal);
  }
}
</style>
